import { useStorage } from '@vueuse/core';

/**
 * Origin-scoped tenant storage used by request providers and tenant transitions.
 */
export function useLocationStorage() {
  const lastLocationId = useStorage<string | null>('last-location-id', null, localStorage);

  return {
    getLocationId: () => lastLocationId.value,
    setLocationId: (id: string | null) => {
      lastLocationId.value = id;
    },
    clearLocationId: () => {
      lastLocationId.value = null;
    },
  };
}

export function useOrganizationStorage() {
  const organizationIdSession = useStorage<string | null>('organization-id', null, sessionStorage);
  const organizationIdLocal = useStorage<string | null>('organization-id', null, localStorage);

  const getOrganizationId = (): string | null => {
    return organizationIdSession.value ?? organizationIdLocal.value;
  };

  const setOrganizationId = (organizationId: string | null) => {
    organizationIdSession.value = organizationId;
    organizationIdLocal.value = organizationId;
  };

  const resetOrganizationId = () => {
    organizationIdSession.value = null;
    organizationIdLocal.value = null;
  };

  return {
    getOrganizationId,
    setOrganizationId,
    resetOrganizationId,
  };
}
